import localforage from 'localforage';

// Configure localforage
localforage.config({
  name: 'clive-app',
  storeName: 'clive-app-storage',
  description: 'Clive App Storage',
});

/**
 * Storage wrapper for localForage with typed get/set operations
 */
const storage = {
  /**
   * Get a value from storage
   * @param key - The key to retrieve
   * @param defaultValue - Optional default value if key doesn't exist
   * @returns The stored value or defaultValue if not found
   */
  get: async <T>(key: string, defaultValue?: T): Promise<T | undefined> => {
    try {
      const value = await localforage.getItem<T>(key);
      return value !== null ? value : defaultValue;
    } catch (error) {
      console.error(`Error getting item from storage: ${key}`, error);
      return defaultValue;
    }
  },

  /**
   * Set a value in storage
   * @param key - The key to store
   * @param value - The value to store
   * @returns Promise that resolves when the operation completes
   */
  set: async <T>(key: string, value: T): Promise<void> => {
    try {
      await localforage.setItem(key, value);
    } catch (error) {
      console.error(`Error setting item in storage: ${key}`, error);
    }
  },

  /**
   * Remove a value from storage
   * @param key - The key to remove
   * @returns Promise that resolves when the operation completes
   */
  remove: async (key: string): Promise<void> => {
    try {
      await localforage.removeItem(key);
    } catch (error) {
      console.error(`Error removing item from storage: ${key}`, error);
    }
  },

  /**
   * Clear all values from storage
   * @returns Promise that resolves when the operation completes
   */
  clear: async (): Promise<void> => {
    try {
      await localforage.clear();
    } catch (error) {
      console.error('Error clearing storage', error);
    }
  },
};

export default storage;
